import { CreateOrganization } from '../pages';
import { WithRouteData } from '../render-routes';

export const CreateOrganizationPage = () => {
  return <CreateOrganization />;
};

export default WithRouteData(CreateOrganizationPage);
